module.exports = {"341522100":"城关镇","341522101":"河口镇","341522102":"周集镇","341522103":"临水镇","341522104":"新店镇","341522105":"石店镇","341522106":"马店镇","341522107":"孟集镇","341522108":"花园镇","341522109":"扈胡镇","341522110":"长集镇","341522113":"乌龙镇","341522114":"高塘镇","341522115":"龙潭镇","341522116":"岔路镇","341522117":"冯井镇","341522118":"众兴集镇","341522119":"夏店镇","341522120":"曹庙镇","341522123":"范桥镇","341522124":"潘集镇","341522200":"彭塔乡","341522201":"王截流乡","341522203":"临淮岗乡","341522204":"城西湖乡","341522205":"宋店乡","341522206":"三流乡","341522207":"邵岗乡","341522208":"白莲乡","341522210":"冯瓴乡","341522400":"安徽霍邱经济开发区","341522500":"水产局管辖村"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341522.json
// module id = 1141
// module chunks = 0